import { IconChooser, IconChooserProps } from '@components/icon-chooser/icon-chooser';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormIconChooserProps<T> = FormFieldProps<IconChooserProps, T>;

export function FormIconChooser<T>(props: FormIconChooserProps<T>) {
  const formFieldProps = useFormField({ ...props, valueType: 'icon-chooser' });

  return <IconChooser {...props} {...formFieldProps} />;
}
